import * as React from "react";
import BaseWSTmp from "./base-ws-tmp";
import renderHtml from "./dialogNotice/convertDraftToHtml";
import { EPtype } from "utils/enum/notice";
import { WordBreakProperty } from "csstype";

// 客服(群组)接受or发送的消息模板

interface INCSWSTmpProps {
  // 发送给xxx
  to?: any;
  // 发送者
  from?: any;
  // 消息是否已被接受者读过了
  beread?: any;
  // 消息内容
  content?: any;
  // 消息面向的人群 当个人 | 群组
  ptype?: any;
}

// 角色
enum ERole {
  // 消息发送者
  Send,
  // 消息接收者
  Receiver
}

class NCSWSTmp extends React.Component<INCSWSTmpProps, any> {
  role = ERole.Send;

  constructor(props: INCSWSTmpProps) {
    super(props);
  }

  componentWillMount() {
    //    this.getRole();
  }

  // getRole = () => {
  //   const { to, from } = this.props;
  //   // 发送者
  //   if (!!to && !from) {
  //     this.role = ERole.Receiver;
  //   } else if (!to && !!from) {
  //     this.role = ERole.Send;
  //   } else {
  //     console.warn("to 和 from 不能同时有值，to:接受者 from:发送者");
  //   }
  // };

  getTitle = () => {
    // if (ERole.Send === this.role) {
    //   return "你@了" + this.props.to;
    // } else {
    //   return this.props.from + "@了你";
    // }

    const { from, to } = this.props;

    return from + "@了" + to;
  };

  // 获取发送的消息的读取状态
  getReadState = () => {
    const { beread, ptype, to } = this.props;
    if (ERole.Send === this.role && !!beread) {
      const _ptype = parseInt(ptype);
      if (EPtype.Group === _ptype) {
        return beread + "人已读";
      } else {
        return to + "已读";
      }
    }
    return "";
  };

  // 渲染消息内容
  renderContent = content => {
    return renderHtml(content);
  };

  contentStyle = {
    color: "#999999",
    marginTop: "4px",
    lineHeight: "16px",
    wordBreak: "break-all" as WordBreakProperty
  };

  render() {
    const content = (
      <div className="ncs-notice">
        <a href="javascript:void(0)">{this.getTitle()}</a>
        <span className="tag__receiver"> {this.getReadState()} </span>
        <div style={this.contentStyle}>
          {this.renderContent(this.props.content)}
        </div>
      </div>
    );
    return <BaseWSTmp {...this.props} slot={content} />;
  }
}

export default NCSWSTmp;
